export default "__VITE_ASSET__CgJ0HsGM__"